import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Approvalform, EmployeeAssesment, Hike } from 'src/app/shared/models/appraisal';
import { Message } from 'src/app/shared/models/domain';
import { ApparaisalService } from 'src/app/shared/services/apparaisal.service';
import { CommonService } from 'src/app/shared/services/common.service';
@Component({
  selector: 'app-approval-hike',
  templateUrl: './approval-hike.component.html',
  styleUrls: ['./approval-hike.component.scss']
})
export class ApprovalHikeComponent implements OnInit {
  // @Output() hike = new EventEmitter<Hike>();
  public hike: Hike[];
  @Input() employeeAssesment!: EmployeeAssesment;
  @Input() isActive: boolean;
  @Output() emitWizardIndex = new EventEmitter<number>();

  public submitted: boolean = false;
  public hikeForm: FormGroup;
  private modified: boolean = false;
  public isAssesmentCompleted: boolean = false;

  constructor(
    private appraisalServices: ApparaisalService,
    private commonService: CommonService,
    private fb: FormBuilder,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
    this.isAssesmentCompleted = this.commonService.isAssesmentCompleted(this.employeeAssesment.status);
    this.setHikeForm();
    this.getHike();
    // this.getEmployeeAssessment();
  }

  // public getEmployeeAssessment(): void {
  //   if (this.employeeAssesment?.appraisalId && this.employeeAssesment?.appraiseeId) {
  //     this.appraisalServices.getAssessment(this.employeeAssesment.appraisalId, this.employeeAssesment.appraiseeId).subscribe({
  //       next: (employeeAssessment: EmployeeAssesment) => {
  //         this.employeeAssesment = employeeAssessment;
  //         if(this.employeeAssesment?.hikeDto){
  //           this.setHikeForm(this.employeeAssesment?.hikeDto)
  //         }
  //       },

  //       error: (error: HttpErrorResponse) => {
  //         this.commonService.setToastr(500, 'Failed to load employee assessment');
  //       }
  //     });
  //   }
  // }

  public setHikeForm(hike?: Hike) {
    if (!hike) hike = {
      id: null,
      lastPromotion: null,
      reasonToHike: null,
      reasonNotToHike: null,
      value: 0,
      type: null,
      previouslyRejected: false,
      applicable: false,
      assessmentId: null,
      status: 'LONE_HIKE',
    } as Hike
    this.hikeForm = this.fb.group({
      id: this.fb.control(hike?.id),
      lastPromotion: this.fb.control(hike?.lastPromotion, []),
      reasonToHike: this.fb.control(hike?.reasonToHike, []),
      reasonNotToHike: this.fb.control(hike?.reasonNotToHike, []),
      value: this.fb.control(hike?.value, []),
      type: this.fb.control(hike?.type, []),
      previouslyRejected: this.fb.control(hike?.previouslyRejected, []),
      applicable: this.fb.control(hike?.applicable, []),
      assessmentId: this.fb.control(hike?.assessmentId || this.employeeAssesment?.id, []),
      status: this.fb.control(hike?.status, []),
    });
    this.hikeForm.valueChanges.subscribe(value => this.modified = true);
  }

  get m() {
    return this.hikeForm.controls;
  }

  public saveHike() {
    if (this.isActive) {
      return;
    }
    if (this.hikeForm.valid) {
      let hike: Hike = this.hikeForm.value as Hike;

      if (hike.id) {
        this.appraisalServices.updateHike(hike.id, hike).subscribe({
          next: (message: Message) => {
            if (!message.failed) {
              this.commonService.setToastr(200, message.text);
              this.emitWizardIndex.emit(4);
            } else {
              this.commonService.setToastr(500, message.text);
            }
          },
          error: (err: any) => {
            this.commonService.setToastr(500, "Failed to Save Promotion");
          }
        });
      } else {
        this.appraisalServices.createHike(hike).subscribe({
          next: (message: Message) => {
            if (!message.failed) {
              this.commonService.setToastr(200, "Hike Saved successfully");
              this.upsertAppraisalStatus();
            } else {
              this.commonService.setToastr(500, message.text);
            }
          },
          error: (err) => {
            this.commonService.setToastr(500, "Error Saving Hike");
          }
        });
      }
    }
    else {
      this.commonService.setToastr(400, "Please enter valid hike details!");
    }
  }

  public upsertAppraisalStatus() {
    this.appraisalServices.updateAppraisalStatus(this.employeeAssesment.id,'LONE_HIKE').subscribe({
      next: (response: Message) => {
        if (!response.failed) {
          this.emitWizardIndex.emit(4);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error(error?.error?.error || error.error);
      }
    });
  }

  public getHike() {
    if (this.employeeAssesment.id) {
      this.appraisalServices.getHike(this.employeeAssesment.id).subscribe({
        next: (hike: Hike[]) => {
          this.hike = hike;
          if (hike && hike.length > 0) {
            this.setHikeForm(hike[0]);
          }
        },
        error: (error: HttpErrorResponse) => {
        }
      });
    }
  }
}

